<template>
  <div class="" style="margin: 0 -14px;">
    <router-view v-if="$route.name != 'course'" />
    <a-tabs style="padding: 0 14px;" :tabBarStyle="{ 'font-size': '18px' }" v-model="activeKey"
      v-show="$route.name == 'course'">
      <a-tab-pane :tab="item" v-for="(item, index) of tabList" :key="index">
        <study-plan ref="studyPlan" :planClassesId="activeId" v-if="item === '学习计划'"></study-plan>
        <my-course v-if="item === '我的课程'" :planClassesId="activeId || setPlanclassesId"
          :planclassesName="activePlanclassesName" :showCourseProgress="isShowCourseProgress"></my-course>
      </a-tab-pane>
      <div slot="tabBarExtraContent" class="d-flex">
        <!-- :style="{'margin-right':activeKey == 0?'0px':'92px'}"  -->
        <a-select show-search option-filter-prop="children" v-show="activeKey !== 1"
          v-model="activeId" @change="activeIdChange" style="width: 300px;font-size:14px;color:#547FF5;">
          <a-icon slot="suffixIcon" type="swap" style="color:#547FF5" />
          <a-select-option :value="plan.id" v-for="plan in studyPlanList" :key="plan.id">
            {{ plan.className }}
          </a-select-option>
        </a-select>
        <a-button
          v-show="activeKey !== 1"
          style="margin-left: 16px;"
          shape="round"
          :type="isShowCourseProgress ? 'default' : 'primary'"
          @click="toggleCourseProgress"
        >
          {{ isShowCourseProgress ? '隐藏课程进度' : '显示课程进度' }}
        </a-button>
        <div v-if="activeKey !== 1" @click="toExpireCourse" class="d-flex overdue">
          <img :src="allSchedule" alt="" style="width: 16px;margin-right:6px;margin-left: 24px;" />
          <span>过期课程</span>
        </div>
      </div>
    </a-tabs>
  </div>
</template>
<script>
import Vue from 'vue'
import myClassDetail from './myClassDetail/index.vue'
import studyPlan from '../components/StudyPlan'
import myCourse from '../myCourse/myCourse.vue'
import myCourseNoApply from '../myCourse/myCourseNoApply.vue'
import { studyPlanList } from '@/api/user'
import { mapMutations, mapState } from 'vuex'
import allSchedule from '@/assets/icons/all_schedule1.png'

export default {
  name: 'CouresPage',
  components: {
    myClassDetail,
    myCourse,
    studyPlan,
    myCourseNoApply
  },
  data() {
    return {
      allSchedule,
      activeKey: 0,
      studyPlanList: [],
      activeId: '0',
      activePlanclassesName: '',
      isShowCourseProgress: false,
      isAudition: false, // 是否意向
      tabList: [],

    }
  },
  created() {
    if (this.$route.params.refresh) {
      this.$route.params.refresh = false
      this.activeKey = 1
    }
  },
  activated() {
    const userInfo = Vue.ls.get('USER_INFO')
    if (userInfo.isAudition) {
      this.tabList = ['我的课程']
    } else {
      this.studyPlanListAsync()
      this.tabList = ['我的课程', '学习计划']
    }
  },
  computed: {
    ...mapState('course', ['planclassesId']),
  },
  methods: {
    ...mapMutations('course', ['setPlanclassesId']),
    activeIdChange(val) {
      console.log(val)
      // 切换班级后默认不展示/不加载课程进度
      this.isShowCourseProgress = false
      this.setPlanclassesId(val)
      // this.setPlanclassesId = val
    },
    toggleCourseProgress () {
      this.isShowCourseProgress = !this.isShowCourseProgress
    },
    async studyPlanListAsync() {
      console.log('planclassesId', this.planclassesId)
      try {
        const res = await studyPlanList()
        // this.studyPlanList.push(...res)
        this.studyPlanList = [
          ...res
        ]
        if (this.planclassesId) {
          this.activeId = this.planclassesId
          this.setPlanclassesId(this.planclassesId)
          for (const item of this.studyPlanList) {
            if (item.id === this.planclassesId) {
              this.activePlanclassesName = item.name
            }
          }
        } else {
          this.activeId = res[0].id
          this.setPlanclassesId(res[0].id)
          // console.log('vuex', this.setPlanclassesId)
          this.activePlanclassesName = res[0].name
        }
      } catch (error) {
        console.log(error)
      }
    },
    toExpireCourse() {
      this.$router.push({
        name: 'expireCourse',
        query: { ocode: Vue.ls.get('code') },
      })
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .ant-progress-bg {
  background: #4B7DFD !important;
}

/deep/.ant-select-selection {
  // border-radius: 16px;
  width: 300px;
  height: 30px;
  // margin-right:32px;
  background: #F3F6FE;
  border-radius: 6px 6px 6px 6px;
  opacity: 1;
  border: 1px solid #95B1FF;
  color: #547FF5;
  font-size: 14px;
}

/deep/ .ant-tabs-nav-scroll {
  margin-bottom: 0px;
}

/deep/ .ant-tabs-ink-bar {
  height: 0;
}

// /deep/ .ant-tabs-tab {
//   // color:#84878D;
// }
.overdue {
  cursor: pointer;
  color: #1564ff;
  font-size: 12px;
  // margin-left:32px;
  // position: absolute;
  // top: 15px;
  // right: 30px;
}

/deep/ .ant-tabs-tab {
  font-size: 18px;
  font-weight: 600;
  color: #84878D;
  position: relative;
  display: inline-block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 100%;
  margin: 0 32px 0 0;
  padding: 12px 16px;
  text-decoration: none;
  cursor: pointer;
  -webkit-transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

/deep/ .ant-tabs-nav .ant-tabs-tab-active {
  color: #4B7DFD;
  text-shadow: 0 0 0.25px currentColor;
}
</style>
